var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6819 2.02998C4.82022 2.08887 4.91 2.22467 4.91 2.37501V5.8741H6.875C7.00835 5.8741 7.13167 5.94492 7.19889 6.0601C7.2661 6.17527 7.26709 6.31748 7.20149 6.43358L6.95545 6.86901C6.02239 8.52033 4.83245 10.0126 3.43029 11.2899L3.03253 11.6522C2.92275 11.7522 2.7643 11.778 2.62846 11.718C2.49263 11.658 2.405 11.5235 2.405 11.375V7.90558H0.375C0.167893 7.90558 0 7.73769 0 7.53058C0 7.4635 0.0176127 7.40053 0.0484659 7.34605C0.927861 5.72033 2.05375 4.24059 3.38611 2.95948L4.27508 2.1047C4.38345 2.0005 4.54357 1.97109 4.6819 2.02998ZM1.01729 7.15558H2.78C2.98711 7.15558 3.155 7.32347 3.155 7.53058V10.5223C4.3643 9.37949 5.40084 8.06634 6.2317 6.6241H4.535C4.32789 6.6241 4.16 6.45621 4.16 6.2491V3.25582L3.90594 3.50011C2.78055 4.58221 1.80891 5.81222 1.01729 7.15558Z",
    fill: "#272727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9375 3H11.0625",
    stroke: "#272727",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.9375V5.0625",
    stroke: "#272727",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningAlt);
export default __webpack_public_path__ + "static/media/lightning-alt.e269b5d4394851923743add61993bcab.svg";
export { ForwardRef as ReactComponent };